import ContractsMileageCargoCompanyDetailsRequest, {
  ContractsMileageCargoCompanyDetailsQueryParams,
} from "./contracts-mileage-cargo-company-details.request";

const createQueryParams = (
  request: ContractsMileageCargoCompanyDetailsRequest,
): ContractsMileageCargoCompanyDetailsQueryParams => {
  return {
    validAt: request.validAt,
  };
};

const contractsMileageCargoCompanyDetailsRequestFactory = {
  createQueryParams,
};

export default contractsMileageCargoCompanyDetailsRequestFactory;
